import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

import AudioPlayer from "../../components/AudioPlayer";
import AudioFile from "../../assets/audio/Amyvid_Indication_LOU.mp3";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_1 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <div className="col-sm-8 module-content">
        <section className="mb-5">
          <h1 className="blue text-uppercase b mt-5">
            Indication and Limitations of Use
          </h1>
          <p className="mt-3">Estimated time to complete: 2 minutes</p>
        </section>
        <section>
          <AudioPlayer audioSrc={AudioFile} nextUrl={"/module-4/isi"}>
            <p>Please <strong>click play on the audio player</strong> to ensure you have reviewed the<br />Indication and Limitations of Use <strong>before advancing to the next page</strong>.</p>
          </AudioPlayer>
          <h2 className="h5 b">Amyvid Indication and Usage</h2>
          <p>
            Amyvid is a radioactive diagnostic agent for Positron Emission Tomography (PET) imaging of the brain to estimate beta-amyloid neuritic plaque density in adult patients with cognitive impairment who are being evaluated for Alzheimer's Disease (AD) and other causes of cognitive decline.
          </p>
          <p>
            A negative Amyvid scan indicates sparse to no neuritic plaques and
            is inconsistent with a neuropathological diagnosis of AD at the time
            of image acquisition; a negative scan result reduces the likelihood
            that a patient's cognitive impairment is due to AD.
          </p>
          <p>
            A positive Amyvid scan indicates moderate to frequent amyloid
            neuritic plaques; neuropathological examination has shown this
            amount of amyloid neuritic plaque is present in patients with AD,
            but may also be present in patients with other types of neurologic
            conditions, as well as older people with normal cognition. Amyvid is
            an adjunct to other diagnostic evaluations.
          </p>
          <p>
            <strong>Limitations of Use:</strong>
            <ul>
              <li>A positive Amyvid scan does not establish a diagnosis of AD or other cognitive disorder</li>
              <li>
                Safety and effectiveness of Amyvid have not been established
                for:
              </li>
              <ul>
                <li>
                  Predicting development of dementia or other neurologic
                  condition
                </li>
                <li>Monitoring responses to therapies</li>
              </ul>
            </ul>
          </p>
          <p>
            Amyvid for intravenous use is supplied in multidose vials containing
            500-1900 MBq/mL Florbetapir F 18.
          </p>
        </section>
        <section className="button-control">
          <LdsButton
            classes="white-button mt-3 mb-5 prev"
            onClick={function navClick() {
              window.open("/module-4/overview", "_self");
            }}
          >
            Previous Lesson
          </LdsButton>

          <LdsButton classes="blue-button mt-3 mb-5 align-self-right float-end next" disabled={true} id="next">
            Next Lesson
          </LdsButton>
        </section>
      </div>
    </div>
  );
};

export default Module_1_1;
